import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { lucideIcons } from '@/app/core/auto-generated/lucide';

export const provideIcons = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      const domSanitizer = inject(DomSanitizer);
      const matIconRegistry = inject(MatIconRegistry);

      // Server-configured dashboard icons can use names outside the source subset.
      // Material fetches this catalogue only when no registered literal matches.
      matIconRegistry.addSvgIconSet(
        domSanitizer.bypassSecurityTrustResourceUrl('icons/lucide.svg'),
        { viewBox: '0 0 24 24' }
      );

      // Lucide icons — the default for bare `<mat-icon svgIcon="…">` (chrome).
      matIconRegistry.addSvgIconSetLiteral(
        domSanitizer.bypassSecurityTrustHtml(lucideIcons),
        { viewBox: '0 0 24 24' }
      );

      // Material Symbols (icon font) — opt-in via `<mat-icon fontSet="symbols">`
      // for dense table cells, where a text ligature beats a cloned SVG.
      matIconRegistry.registerFontClassAlias(
        'symbols',
        'material-symbols-outlined'
      );
    }),
  ]);
